// import * as firebase from "firebase";
import * as React from "react";

// const FIREBASE_CONFIG = {
//     apiKey: "AIzaSyDfcL3-mCpGgUyt4Q1iWAirzTMLT3m6Ud4",
//     authDomain: "warpprism-ebc5e.firebaseapp.com",
//     databaseURL: "https://warpprism-ebc5e.firebaseio.com",
//     projectId: "warpprism-ebc5e",
//     storageBucket: "warpprism-ebc5e.appspot.com",
//     messagingSenderId: "867636939716"
// };

export class Chat extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            
        }

        // this.fb = firebase  
        //     .initializeApp(FIREBASE_CONFIG)
        //     .database()
        //     .ref();

        // this.fb.on('value', snapshot => {  
        //     console.log(snapshot.val());
        // });
    }

    render() {
        return (
            <div>
                 
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./react/components/Chat.jsx